import { render, staticRenderFns } from "./SingleChart.vue?vue&type=template&id=194c684c&scoped=true"
import script from "./SingleChart.vue?vue&type=script&lang=js"
export * from "./SingleChart.vue?vue&type=script&lang=js"
import style0 from "./SingleChart.vue?vue&type=style&index=0&id=194c684c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194c684c",
  null
  
)

export default component.exports